import script from "./base-device-permissions-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./base-device-permissions-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__